import { Card, Dropdown, FloatButton, Tooltip } from 'antd'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SureModal from 'src/components/Modals/SureModal'
import AddNewAbonementCost from '../Modals/AddNewAbonementCost'
import EditNewAbonementCost from '../Modals/EditNewAbonementCost'
import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import { deleteAbonementClub, getAbonementListClubItems, getAbonementListClubServices, getAbonementsListClubs } from 'src/store/Slices/AbonementsSlice'
import { getClubs } from 'src/store/Slices/ClientsSlice'
import { openNotification } from 'src/components/helpers/notification';

const MobileAbonementsCost = ({
    abonementsClubsList,
    abonementsClubsListLoading,
    setTab,
    abonementInfo,
    abonementCostInfo,
    setAbonementCostInfo,
    mnemo
}) => {

    const dispatch = useDispatch()
    const items = [
        {
            key: '1',
            label: 'Редактировать',
            onClick: () => { setIsOpenEditModal(true) },
            disabled: (!mnemo?.children?.find(el => el.name === 'Абонемент-клубы')?.children.find(ele => ele.mnemo === 'updateBtn'))
        },
        {
            key: '2',
            label: 'Удалить',
            onClick: () => { setIsOpenDeleteModal(true) },
            disabled: (!mnemo?.children?.find(el => el.name === 'Абонемент-клубы')?.children.find(ele => ele.mnemo === 'deleteBtn'))
        },
    ];

    const [isOpenModal, setIsOpenModal] = useState(false)
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
    const [isOpenEditModal, setIsOpenEditModal] = useState(false)

    const onClickDelete = () => {
        dispatch(deleteAbonementClub({
            abonementClubId: abonementCostInfo.id
        })).then(() => {
            openNotification({
                type: 'success',
                message: `Стоимость пакета успешно удален`
            })
            dispatch(getAbonementsListClubs({ AbonementId: abonementInfo.id }))
            setIsOpenDeleteModal(false)
        })
    }

    useEffect(() => {
        dispatch(getClubs())
    }, [])

    return (
        <>
            <SureModal
                visible={isOpenDeleteModal}
                setVisible={setIsOpenDeleteModal}
                onClickYes={onClickDelete}
            />
            <AddNewAbonementCost
                visible={isOpenModal}
                setVisible={setIsOpenModal}
                abonementInfo={abonementInfo}
            />
            <EditNewAbonementCost
                visible={isOpenEditModal}
                setVisible={setIsOpenEditModal}
                abonementInfo={abonementInfo}
                abonementCostInfo={abonementCostInfo}
            />
            {abonementsClubsList?.data?.value?.rows.map(element => {
                return (
                    <Card
                        loading={abonementsClubsListLoading}
                        title={`Стоимость пакета №: ${element.id}`}
                        extra={<Dropdown
                            menu={{
                                items,
                            }}
                        >
                            <a onClick={() => { setAbonementCostInfo(element) }} className="text-primary text-decoration-none">
                                Действия <DownOutlined />
                            </a>
                        </Dropdown>}
                        style={{ width: 330, marginTop: 16 }}
                        actions={[
                            <div onClick={() => {
                                setAbonementCostInfo(element)
                                setTab('Состав пакета')
                                dispatch(getAbonementListClubItems({ AbonementClubId: element.id }))
                            }}
                            >
                                Состав пакета</div>,
                            <div onClick={() => {
                                setAbonementCostInfo(element)
                                setTab('Услуги')
                                dispatch(getAbonementListClubServices({ AbonementClubId: element.id }))
                            }}
                            >
                                Услуги</div>
                        ]}
                        key={element.id}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div>
                                <div>№:</div>
                                <div>Клуб:</div>
                                <div>Разрешена заморозка:</div>
                                <div>Цена:</div>
                                <div>Кол-во месяцев:</div>
                                <div>Дней заморозки:</div>
                                <div>Имя пакета:</div>
                            </div>
                            <div>
                                <div>{element?.id ? element?.id : '-'}</div>
                                <div>{element?.clubName ? <Tooltip title={element?.clubName}>{element?.clubName.slice(0, 15)}</Tooltip> : '-'}</div>
                                <div>{element?.isFrost ? 'Да' : 'Нет'}</div>
                                <div>{element?.price ? element?.price : '-'}</div>
                                <div>{element?.monthCount ? element?.monthCount : '-'}</div>
                                <div>{element?.frostDays ? element?.frostDays : '-'}</div>
                                <div>{element?.packetName ? <Tooltip title={element?.packetName}>{element?.packetName.slice(0, 15)}</Tooltip> : '-'}</div>
                            </div>
                        </div>
                    </Card>
                )
            })}
            <FloatButton
                disabled={(!mnemo?.children?.find(el => el.name === 'Абонемент-клубы')?.children.find(ele => ele.mnemo === 'insertBtn'))}
                style={{ right: 24 }}
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                    setIsOpenModal(true)
                }}
            />
        </>)
}

export default MobileAbonementsCost